import { EnrichedItem } from '../types';
export const splitArray = (array: EnrichedItem[], size: number) => {
  const subarray: EnrichedItem[][] = [];
  for (let i = 0; i < Math.ceil(array.length / size); i++) {
    subarray[i] = array.slice(i * size, i * size + size);
  }
  return subarray;
};
